<template>
  <div>
    <NavBar />
    <v-main>
      <v-container fluid>
        <Tabs class="">
          <Tab label="Open Findings">
            <OpenFindings />
          </Tab>
          <Tab label="Findings Archive">
            <Archive />
          </Tab>
        </Tabs>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Archive from '@/components/shared/archive'
import NavBar from '@/components/UI/nav-bar'
import OpenFindings from '@/components/shared/open-findings'

export default {
  name: 'OBHome',
  components: {
    Archive,
    NavBar,
    OpenFindings,
  },
  mounted() {
    this.$emit('loaded')
  },
  setup() {
    return {}
  }
}
</script>
